import { sendContactEmail } from "./sendContactEmail";
import { getVisitorInfo } from "./utm";

const STORAGE_KEY = "portfolio-visit-notified-at";
const COOLDOWN_MS = 6 * 60 * 60 * 1000;
const OWNER_EMAIL = "hirensurani1997@gmail.com";

function claimedRecently() {
  try {
    const at = Number(localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(at) && Date.now() - at < COOLDOWN_MS;
  } catch {
    return false;
  }
}

function markNotified() {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // Private mode can block storage; still send this once.
  }
}

function clearNotified() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
}

function browserLabel(userAgent) {
  const ua = userAgent || "";
  if (/Edg\//.test(ua)) return "Edge";
  if (/Firefox\//.test(ua)) return "Firefox";
  if (/Chrome\//.test(ua)) return "Chrome";
  if (/Safari\//.test(ua)) return "Safari";
  return "Unknown browser";
}

function locationLine(location) {
  if (!location || location.error) return "Unavailable";
  const place = [location.city, location.region, location.country_name]
    .filter(Boolean)
    .join(", ");
  const ip = location.ip ? ` (IP ${location.ip})` : "";
  return place ? `${place}${ip}` : ip.trim() || "Unavailable";
}

function buildVisitMessage(location) {
  const visitor = getVisitorInfo();
  const campaign = [visitor.source, visitor.medium, visitor.campaign]
    .filter(Boolean)
    .join(" / ");

  return [
    "Reason: someone opened your portfolio.",
    "",
    "This is an automatic visit alert. It is not a message from Let’s Connect or the chat, and the visitor did not leave their email.",
    "",
    `Page: ${window.location.href}`,
    `Location: ${locationLine(location)}`,
    `Referrer: ${visitor.referrer || "Direct"}`,
    `Campaign: ${campaign || "None"}`,
    `Browser: ${browserLabel(visitor.userAgent)}`,
    `Time: ${new Date().toLocaleString()}`,
  ].join("\n");
}

/**
 * Email once when a visitor loads the portfolio, using the same EmailJS
 * template as Let’s Connect. The message states why the email was sent.
 * Repeat visits from the same browser inside 6 hours are skipped.
 */
export async function notifyPortfolioVisit(location) {
  if (typeof window === "undefined") return;
  if (navigator.webdriver) return;
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return;
  if (claimedRecently()) return;

  markNotified();

  const place = locationLine(location);
  const result = await sendContactEmail({
    name: "Portfolio visitor",
    email: OWNER_EMAIL,
    phone: "Not provided",
    company: place === "Unavailable" ? "Not provided" : place,
    message: buildVisitMessage(location),
    source: "portfolio-visit",
  });

  if (!result.success) {
    clearNotified();
    console.error("Portfolio visit email failed:", result.error);
  }
}
